import * as THREE from 'three';
import {
  BEKIJKEN_PANEL,
  bekijkenButtons,
  bekijkenPanelAt,
  type BekijkenAction,
  type BekijkenPanelInput,
} from '../bekijken/panel.js';
import { Button } from './panel.js';

/**
 * The Bekijken panel drawn (ADR-058): one Button per bekijkenButtons entry in a group the caller hangs
 * on the lectern's. The lit state or clip and Sluiten are primary, the others secondary; the item's
 * and the features' names are labels that do nothing.
 */
export class BekijkenPanel {
  readonly group = new THREE.Group();
  readonly buttons: Button[] = [];
  readonly pressable: Button[] = [];

  constructor(input: BekijkenPanelInput, onPress: (action: BekijkenAction) => void) {
    for (const spec of bekijkenButtons(input)) {
      const pressed = spec.action.kind !== 'none';
      const lit = spec.current || spec.action.kind === 'close';
      const button = new Button(spec.label, () => onPress(spec.action), {
        width: spec.width,
        height: BEKIJKEN_PANEL.rowHeight,
        kind: !pressed ? 'muted' : lit ? 'primary' : 'secondary',
      });
      button.mesh.position.set(spec.x, spec.y, 0.002);
      this.group.add(button.mesh);
      this.buttons.push(button);
      if (pressed) this.pressable.push(button);
    }
    const at = bekijkenPanelAt();
    this.group.position.set(at.x, at.y, 0);
    this.group.name = 'bekijken-panel';
  }

  dispose(): void {
    for (const button of this.buttons) button.dispose();
    this.group.removeFromParent();
  }
}
